import React from 'react';
import choose1 from "../../../assets/images/resource/choose-01.png";
import choose2 from "../../../assets/images/resource/choose-02.png";
import choose3 from "../../../assets/images/resource/choose-02.png";
import choose4 from "../../../assets/images/resource/choose-02.png";

const Choose = () => {
    return (
        <section className="choose__us p_relative">
            <div className="choose__us__data">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="choose__block">
                                <figure>
                                    <img src={choose1} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="choose__block__right">
                                <div className="title__data">
                                    <div className="sub__title">
                                        <h4><br/>Why choose us</h4>
                                    </div>
                                    {/* <div className="title">
                                        <h2>We Provide Your Best Work </h2>
                                    </div> */}
                                </div>
                                <div className="team__data">
                                    <div className="team__data__right">
                                        <h3>✅ Proven Expertise :</h3>
                                        <p>With extensive experience in engineering simulation, artificial intelligence, and emerging technologies, ERI delivers innovative, high-impact solutions tailored to complex challenges. Our team brings deep technical knowledge and hands-on experience to drive meaningful advancements.</p>
                                    </div>
                                </div>
                                <div className="team__data">
                                    <div className="team__data__right">
                                        <h3>🏛  Federal Prime Contractor :</h3>
                                        <p>As a prime contractor for Department of Defense (DoD) agencies and commercial clients, ERI has successfully executed projects for organizations such as the U.S. Army, U.S. Air Force, Missile Defense Agency, and Defense Health Agency. Our deep understanding of federal contracting, compliance, and mission-critical solutions positions us as a reliable and strategic partner.</p>
                                    </div>
                                </div>
                                <div className="team__data three">
                                    <div className="team__data__right">
                                        <h3>🤝 Strong Collaborations :</h3>
                                        <p>ERI believes in the power of collaboration and interdisciplinary research. We partner with leading universities, private firms, and government agencies to foster innovation and bring groundbreaking ideas to life. These collaborations enhance our ability to tackle complex problems with fresh perspectives and cutting-edge technology.</p>
                                    </div>
                                </div>
                                <div className="team__data three">
                                    <div className="team__data__right">
                                        <h3>🎯 Mission-Driven Approach :</h3>
                                        <p>At ERI, we are driven by a commitment to advancing science and technology. We focus on solving real-world challenges in engineering, life sciences, and healthcare, ensuring that our research and solutions have a lasting impact. Whether it's enhancing national security, developing engineering and/or AI simulation tools, or advancing biomedical technology, our mission is to deliver excellence in every project.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Choose;